import React, { useState, useEffect, useMemo, useRef } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import "./MenuConfigurations.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Radio } from "antd";
import {
  addConfigVal,
  getAllEnvCategories,
  getAllEnvConfigVal,
  updateConfigVal,
} from "../../apis/createEnvApi/createEnvApi";

import { useDispatch, useSelector } from "react-redux";
import {
  MenuItem,
  FormControl,
  Select,
  TextField,
  Modal,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import MenuConfigActions from "../../components/MenuConfigActions/MenuConfigActions";
import filterIcon from "../../assets/icons/filtericon.svg";
import addIcon from "../../assets/icons/addItemIcon.svg";
import Pagination from "../../components/Pagination/Pagination";
import closeIcon from "../../assets/icons/closeIcon.svg";

function MenuConfig() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const EmpId = useSelector((state: any) => state.authApiSlice.Id);
  const ActiveClient = useSelector(
    (state: any) => state.clientDetails.activeClient
  );
  const [configList, setConfigList] = useState<any[]>([]);
  const [originalConfigList, setOriginalConfigList] = useState<any[]>([]);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedEnv, setSelectedEnv] = useState<any>("");
  const [selectedCategory, setSelectedCategory] = useState<any>(null);
  const [rowId, setRowId] = useState(null);
  const [dataGrid, setDataGrid] = useState<any>(null);
  const [openFilter, setOpenFilter] = useState(false);
  let filterRef = useRef<any>("");
  const filterSearchInputref = useRef<any>(null);

  const columns = [
    { field: "Code_Decode_Locale_Id", headerName: "Language" },
    { field: "Code_Code", headerName: "Key Name" },
    {
      field: "Code_Decode_Short_Desc",
      headerName: "Display Name",
    },
    { field: "Code_Decode_Long_Desc", headerName: "Description" },
  ];

  const [seletedFilterType, setSeletedFilterType] = useState<any>(columns[0]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState<any>(10);

  // Get current Rows
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = configList.slice(indexOfFirstRow, indexOfLastRow);

  // Change page
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  const rowCountRange = [10, 25, 50, 100];

  const [openAddItemModal, setOpenAddItemModal] = useState(false);
  const handleCloseAddItemModal = () => setOpenAddItemModal(false);
  const [addItemFormInput, setAddItemFormInput] = useState<any>({});

  useEffect(() => {
    getAllCategories();
    setSelectedEnv(ActiveClient.Env_Data[0]);
  }, []);

  useEffect(() => {
    getAllConfig();
  }, [selectedCategory,selectedEnv]);

  useEffect(() => {
    let handler = (e: any) => {
      if (!filterRef?.current.contains(e.target)) {
        setOpenFilter(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  const getAllCategories = () => {
    console.log("getAllCategories-->")

    let payload={
      "Client_Id":ActiveClient.Client_Id,
      "Env_Id":ActiveClient.Env_Data[0].Env_Id,
      "Env_Name":ActiveClient.Env_Data[0].Env_Name,
    }
    getAllEnvCategories(payload,(resp: any) => {
      if (resp) {
        setCategoryList(resp);
        setSelectedCategory(resp[0]);
        return resp;
      } else {
        navigate("/errorInvalid");
      }
    });
  };
  const getAllConfig = () => {
    if(selectedCategory){
    let payload={
        "Client_Id":ActiveClient.Client_Id,
        "Env_Id":selectedEnv.Env_Id,
        "Env_Name":selectedEnv.Env_Name,
        "Category_Id":selectedCategory.C_CATEGORY
    }
    getAllEnvConfigVal(payload,(resp: any) => {
      if (resp) {
        setConfigList(resp);
        setOriginalConfigList(resp);
      } else {
        navigate("/errorInvalid");
      }
    });
  }
  };

  const handleInputChange = (val: string, index: number) => {
    let list = JSON.parse(JSON.stringify(configList));
    list[index].Code_Decode_Short_Desc = val;
    setConfigList(list);
  };

  const handleChangeEnv = (val: any) => {
    setSelectedEnv(val);
  };
  const handleChangeCategory = (val: any) => {
    setSelectedCategory(val);
  };
  const handleFilterChange = (index: any) => {
    filterSearchInputref.current.value = "";
    setSeletedFilterType(columns[index]);
    setConfigList(originalConfigList);
  };

  const handleAddItemInput = (val: any, fieldName: string) => {
    let addItemFormSData: any = addItemFormInput;
    addItemFormSData[fieldName] = val;
    setAddItemFormInput(addItemFormSData);
  };
  const handleSearch = (value: any) => {
    let searchValue = value.toLowerCase();
    if (searchValue.length >= 2) {
      let cls = originalConfigList.filter((item: any) => {
        return (
          item.Code_Decode_Locale_Id.toLowerCase().includes(searchValue) ||
          item.Code_Code.toLowerCase().includes(searchValue) ||
          item.Code_Decode_Short_Desc.toLowerCase().includes(searchValue) ||
          item.Code_Decode_Long_Desc.toLowerCase().includes(searchValue)
        );
      });
      setConfigList(cls);
    } else {
      setConfigList(originalConfigList);
    }
  };
  const handleSearchByType = (value: any) => {
    let searchValue = filterSearchInputref.current.value.toLowerCase();
    let filterType = seletedFilterType.field;
    if (searchValue.length >= 2) {
      let cls = originalConfigList.filter((item: any) => {
        return item[filterType].toLowerCase().includes(searchValue);
      });
      setConfigList(cls);
    } else {
      setConfigList(originalConfigList);
    }
  };

  const handleAddItemSubmit = (event: any) => {
    event.preventDefault();
    console.log("Add Item DATA--", addItemFormInput);

    let payload = {
      Emp_Id: EmpId,
      Client_Id: ActiveClient.Client_Id,
      // Client_Id: 1266,
      Env_Id: selectedEnv.Env_Id,
      Env_Name:selectedEnv.Env_Name,
      Category_Id: selectedCategory.C_CATEGORY,
      Config_Data: {
        Code: addItemFormInput.UpdatedCode
          ? addItemFormInput.UpdatedCode
          : null,
        Code_Date_Effective: addItemFormInput.Code_Date_Effective
          ? addItemFormInput.Code_Date_Effective
          : null,
        Code_Date_Expiration: addItemFormInput.Code_Date_Expiration
          ? addItemFormInput.Code_Date_Expiration
          : null,
        Code_Decode_Sort_Order: addItemFormInput.Code_Decode_Sort_Order
          ? addItemFormInput.Code_Decode_Sort_Order
          : null,
        Short_Dsc: addItemFormInput.Short_Dsc
          ? addItemFormInput.Short_Dsc
          : null,
        Long_Dsc: addItemFormInput.Long_Dsc ? addItemFormInput.Long_Dsc : null,
        Locale_Id: addItemFormInput.Locale_Id
          ? addItemFormInput.Locale_Id
          : null,
      },
    };
    addConfigVal(payload, async (response: any) => {
      console.log("addConfigVal::--", response);
      if (response) {
        getAllConfig();
        setOpenAddItemModal(false);
      }
    });
  };

  return (
    <>
      <div className="tab-page-layout-1">
        <div className="tab-page-layout-1-header config-header-section">
          <div className="tab-page-layout-1-header-title-label">Configure</div>
          <div className="tab-header-search">
            <div className="search-box config-search-box">
              <FontAwesomeIcon
                className="search-icon"
                icon={["fas", "magnifying-glass"]}
              />

              <div className="search-input-section">
                <input
                  className="search-input"
                  type="text"
                  placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="tab-header-env-dropdown-section">
            <div className="evn-dropdown-div pd-md">
              {ActiveClient.Env_Data.length > 1 && (
                <>
                  <div className="export-flow-title primary-color pd-md">
                    Env
                  </div>
                  <FormControl fullWidth>
                    <Select
                      labelId="select-env-label"
                      id="select-env-flow"
                      className="select-env-dropdown config-env-dropdown"
                      value={selectedEnv}
                      onChange={(e) => handleChangeEnv(e.target.value)}
                    >
                      {ActiveClient.Env_Data?.map((items: any) => {
                        return (
                          <MenuItem key={items.Env_Id} value={items}>
                            {items.Env_Name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </>
              )}
            </div>
          </div>
          <div className="tab-header-category-dropdown-section center-div">
            <div className="evn-category-div pd-md">
              {categoryList.length > 1 && (
                <>
                  <div className="export-flow-title primary-color pd-md">
                    Category
                  </div>
                  <FormControl fullWidth>
                    <Select
                      labelId="select-env-label"
                      id="select-env-flow"
                      className="select-env-dropdown config-env-dropdown"
                      value={selectedCategory}
                      onChange={(e) => handleChangeCategory(e.target.value)}
                      MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
                    >
                      {categoryList?.map((items: any) => {
                        return (
                          <MenuItem key={items.C_CATEGORY} value={items}>
                            {items.T_LONG_DESC}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </>
              )}
            </div>
          </div>
          <div className="tab-header-right-div ">
            <div
              className="filter-btn-section header-icon"
              onClick={() => {
                setOpenFilter(!openFilter);
              }}
            >
              <img src={filterIcon} className="icon-md" />
            </div>
            <div
              className="add-btn-section header-icon"
              onClick={() => setOpenAddItemModal(true)}
            >
              <img src={addIcon} className="icon-md" />
            </div>
          </div>
        </div>
        <div className="tab-page-layout-1-body">
          <div className="tab-page-layout-1-list-header config-list-header">
            <div className="tab-page-layout-1-li-item  font-bold">Language</div>
            <div className="tab-page-layout-1-li-item  font-bold">Key Name</div>
            <div className="tab-page-layout-1-li-item  font-bold">
              Display Name
            </div>
            <div className="tab-page-layout-1-li-item  font-bold">
              Description
            </div>
            <div className="tab-page-layout-1-li-item  font-bold">Actions</div>
          </div>
          <ul
            className="tab-page-layout-1-list-section config-list-section"
            id="client-list-section"
          >
            {currentRows.map((item: any, i) => {
              return (
                <li
                  className="tab-page-layout-1-list-item-section config-list-item-section"
                  key={i}
                >
                  <div className="tab-page-layout-1-li-item">
                    {item.Code_Decode_Locale_Id}
                  </div>
                  <div className="tab-page-layout-1-li-item">
                    {item.Code_Code}
                  </div>
                  <div className="tab-page-layout-1-li-item">
                    {item.Code_Decode_Short_Desc}
                  </div>
                  <div className="tab-page-layout-1-li-item">
                    {item.Code_Decode_Long_Desc}
                  </div>
                  <div className="tab-page-layout-1-li-item">
                    <MenuConfigActions
                      item={item}
                      selectedEnv={selectedEnv}
                      getAllConfig={getAllConfig}
                    />
                  </div>
                </li>
              );
            })}
          </ul>

          <div className="tab-page-layout-1-list-footer config-list-footer">
            <div className="row-count-section">
              <div className="row-count-label center-div">Show per page</div>
              <div className="row-count-dropdown-section center-div">
                <select
                  name="filter-column"
                  id=""
                  className="column-dropdown row-count-dropdown  dropdown-arrow-1"
                  onChange={(e) => setRowsPerPage(e.target.value)} 
                >
                  {rowCountRange.map((item: any, i) => (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="page-number-section center-div">
              <div className="entries-count">
                {rowsPerPage * currentPage - rowsPerPage + 1} to{" "}
                {((rowsPerPage * currentPage)<configList.length)?rowsPerPage * currentPage:configList.length} of {configList.length} entries
              </div>
              <Pagination
                rowsPerPage={rowsPerPage}
                totalRows={configList.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            </div>
          </div>
        </div>
      </div>



      {/* Filter Popup */}
      <div
        className={`filter-popup ${openFilter ? "active" : "inactive"}`}
        ref={filterRef}
      >
        <div className="filter-popup-body">
          <div className="column-dropdown-section center-div">
            <select
              name="filter-column"
              id=""
              className="column-dropdown dropdown-arrow-1"
              onChange={(e) => handleFilterChange(e.target.value)}
            >
              {columns.map((item: any, i) => (
                <option value={i} key={item.field}>
                  {item.headerName}
                </option>
              ))}
            </select>
          </div>
          <div className="filter-input-section center-div">
            <input
              type="text"
              ref={filterSearchInputref}
              className="filter-input"
              placeholder="Search"
              onChange={(e) => {
                handleSearchByType(e.target.value);
              }}
            />
          </div>
        </div>
      </div>


      {/* Add item modal */}
      <Modal
        open={openAddItemModal}
        onClose={handleCloseAddItemModal}
        aria-labelledby="edit-modal-modal-title"
        aria-describedby="edit-modal-modal-description"
      >
        <Box className="modal-1-box">
          <div className="modal-1-header">
            <div className="modal-1-title">Add</div>
            <div
              className="modal-1-close-btn-section"
              onClick={() => {
                setOpenAddItemModal(false);
              }}
            >
              <img src={closeIcon} className="icon-md" />
            </div>
          </div>
          <form onSubmit={handleAddItemSubmit}>
            <div className="model-1-form-body">
              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Language
                </label>
                <input
                  id="client-name-input"
                  className="input-field-1 "
                  required
                  type="text"
                  onChange={(e) =>
                    handleAddItemInput(e.target.value, "Locale_Id")
                  }
                />
              </div>
              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Key Name
                </label>
                <input
                  id="client-name-input"
                  className="input-field-1 "
                  required
                  type="text"
                  onChange={(e) =>
                    handleAddItemInput(e.target.value, "UpdatedCode")
                  }
                />
              </div>
              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Display Name
                </label>
                <input
                  id="client-name-input"
                  className="input-field-1 "
                  required
                  type="text"
                  onChange={(e) =>
                    handleAddItemInput(e.target.value, "Short_Dsc")
                  }
                />
              </div>
              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Description
                </label>
                <input
                  id="client-name-input"
                  className="input-field-1 "
                  required
                  type="text"
                  onChange={(e) =>
                    handleAddItemInput(e.target.value, "Long_Dsc")
                  }
                />
              </div>

              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Start Date
                </label>
                <input
                  type="date"
                  className="input-field-1"
                  onChange={(e) =>
                    handleAddItemInput(e.target.value, "Code_Date_Effective")
                  }
                />
              </div>
              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Expiration Date
                </label>
                <input
                  type="date"
                  className="input-field-1"
                  onChange={(e) =>
                    handleAddItemInput(e.target.value, "Code_Date_Expiration")
                  }
                />
              </div>

              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Decode Sort Order
                </label>
                <input
                  id="client-name-input"
                  className="input-field-1 "
                  required
                  type="text"
                  onChange={(e) =>
                    handleAddItemInput(e.target.value, "Code_Decode_Sort_Order")
                  }
                />
              </div>
            </div>
            <div className="model-1-form-actions center-div">
              <button
                className="rounded-primary-40 btn font--btn export-flow-btn config-cancel-btn"
                onClick={() => {
                  setOpenAddItemModal(false);
                }}
              >
                <div>Cancel</div>
              </button>
              <button
                className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn"
                type="submit"
              >
                <div>Done</div>
              </button>
            </div>
          </form>
        </Box>
      </Modal>
    </>
  );
}

export default MenuConfig;
